import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const CheckIcon = memo(({ color = colors.secondary.main, fontSize = 16, ...rest }: SvgIconProps) => {
  return (
    <SvgIcon width="12" height="10" viewBox="0 0 12 10" fill="none" style={{ fontSize }} {...rest}>
      <path
        d="M0.35694 6.47197C-0.11898 5.99605 -0.11898 5.21418 0.35694 4.73826C0.832861 4.26234 1.61473 4.26234 2.09065 4.73826L3.99434 6.64195L9.90935 0.726936C10.3853 0.251015 11.1671 0.251015 11.6431 0.726936C12.119 1.20286 12.119 1.98473 11.6431 2.46065L4.8442 9.25951C4.67422 9.42948 4.43626 9.56546 4.1983 9.59946C4.13031 9.59946 4.02833 9.63345 3.96034 9.63345C3.65439 9.63345 3.31445 9.49747 3.07649 9.25951L0.35694 6.47197Z"
        fill={color}
      />
    </SvgIcon>
  );
});
